export const SettingsFormSelectors = {
	studentDropdown: 'student-dropdown',
	subjectDropdown: 'subject-dropdown',
	testNameCell: 'test-name-cell',
};
